import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';

export const timers = {
  transitionDuration: 400,
};

export const Root = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 18px 32px;
  position: sticky;
  inset: auto 0 0;
  background-color: ${colors.white};
  box-shadow: 0 -4px 15px 0 ${colors.baseText}14;
  transform: translate(0, 100%);
  transition: transform ${timers.regenerateTransitionDuration}ms ease;

  &.enter-active,
  &.enter-done {
    transform: translate(0, 0);
  }

  & > button {
    flex-shrink: 0;
  }
`;

export const Text = styled.p`
  margin: 0;
  font-size: 11px;
  line-height: 16px;
  font-weight: 400;
  color: ${colors.darkGray1};
`;
